export const shouldUpdateScroll = ({ routerProps: { location } }) => {
    // Force scroll to top on route change, unless it's a hash link
    if (location.hash) {
        return false; // Let browser handle hash
    }
    window.setTimeout(() => window.scrollTo(0, 0), 0);
    return false;
};

export const onRouteUpdate = ({ location, prevLocation }) => {
    if (window._paq) {
        // Set the previous URL if available for better transition tracking
        if (prevLocation) {
            window._paq.push(['setReferrerUrl', prevLocation.href]);
        }

        // Update the custom URL to the current location
        window._paq.push(['setCustomUrl', location.pathname + location.search + location.hash]);
        window._paq.push(['setDocumentTitle', document.title]);

        // Track the page view
        // Use a small timeout to ensure the title tag has been updated by React Helmet/Gatsby Head
        setTimeout(() => {
            window._paq.push(['setDocumentTitle', document.title]);
            window._paq.push(['trackPageView']);
        }, 100);
    }
};
